class CollaboratorList extends TableList {
  /**
   * Constructs an instance of the CampaignList class.
   */
  constructor(app, container, listRow, searchInputId = 'searchTable') {
    super(app, container, listRow, searchInputId)
  }

  prepareRow(row) {
    const page = _.template(this.app.templates[this.listRow]);
    let data = {
      ...row,
      'dateCreated_ll': moment(moment.utc(row.dateCreated.date).toDate()).format('ll'),
      'dateCreated_LT': moment(moment.utc(row.dateCreated.date).toDate()).format('LT'),
      'cancelationDate': _.isEmpty(row.cancelationDate) ? '' : moment(moment.utc(row.cancelationDate.date).toDate()),
    };

    const $page = $(page(data));
    return $page;
  }

  loaderData() {
    return {
      id: null,
      status: this.staticPH,
      dateCreated_ll: this.staticPH,
      dateCreated_LT: this.staticPH,
      email: this.staticPH,
      firstname: this.staticPH,
      lastname: '',
      cancelationDate: this.staticPH
    }
  }

  async renderList() {
    const self = this;

    const $listContainer = this.container;

    $listContainer.empty();

    this.showLoader(this.loaderData());

    const response = await this.app.apis['collaborator'].list();
    window['collaborators'] = {};

    if (typeof response.result != 'undefined' && response.result.length) {
      _.each(response.result, function (row) {
        window['collaborators'][row.id] = row;
        let $row = self.prepareRow(row);
        $row.appendTo($listContainer);
      });
    }

    this.removeLoader();

    return response;
  }
}


(function (aimi_calendar_approval, $, app, undefined) {
  // Private object
  var __this = {};

  app.apis['collaborator'] = function () {
    return {
      'update': async function (id, requestData) {
        let updateResponse = null;
        try {
          updateResponse = await app.putRequest(`/api/collaborator/${app.calendarId}/${id}`, requestData, function () {
          }, function () {
          });
        } catch (error) {
          console.log(error);
        }
        return updateResponse;
      },
      'add': function (requestData) {
        return app.postRequest(`/api/collaborator/${app.calendarId}`, requestData, function () {
        }, function () {
        });
      },
      'save': async function (requestData) {
        if (app.isEmpty(requestData.id)) {
          return this.add(requestData)
        } else {
          return this.update(requestData.id, requestData)
        }
      },
      'delete': function (id) {
        return app.deleteRequest(`/api/collaborator/${app.calendarId}/${id}`, {}, function () {
        }, function () {
        });
      },
      'list': function () {
        return app.getRequest(`/api/collaborator/${app.calendarId}`, {}, function () {
        }, function () {
        });
      },
    }
  }();

  app.apis['approvalSettings'] = function () {
    return {
      'get': function (calendarId) {
        return app.getRequest(`/api/calendar/${app.calendarId}/approval-settings`, {}, function () {
        }, function () {
        });
      },
      'save': function (requestData) {
        return app.postRequest(`/api/calendar/${app.calendarId}/approval-settings`, requestData, function () {
        }, function () {
        });
      }
    }
  }();

  aimi_calendar_approval.view = {

    init: function () {
      const __list = aimi_calendar_approval.list;
      const self = aimi_calendar_approval.view;

      const $form = $('form[name=aimi-collaborator]');

      let $password = $(':input[name=password]', $form)[0];
      let $confirmPassword = $(':input[name=confirm_password]', $form)[0];

      __this.validatePassword = function () {
        if ($password.value !== $confirmPassword.value) {
          $confirmPassword.setCustomValidity("Passwords Don't Match");
        } else {
          $confirmPassword.setCustomValidity('');
        }
      };

      $password.onchange = __this.validatePassword;
      $confirmPassword.onkeyup = __this.validatePassword;

    },

    /**
     * @param {number} id - The unique identifier of the subuser to be edited.
     */
    edit: function (id) {
      let __list = aimi_calendar_approval.list;
      Utils.createAndShowTab('#tab_block_3');
      __list.setViewTabTitle(`Edit Collaborator #${id}`);
      this.setValues(window['collaborators'][id]);
    },

    /**
     * @param {Object} values - An object containing subuser data to populate the form with.
     */
    setValues: function (values) {
      const $form = $('form[name=aimi-collaborator]');
      $(':input[name=id]', $form).val(values.id);
      $(':input[name=email]', $form).val(values.email);
      $(':input[name=firstname]', $form).val(values.firstname);
      $(':input[name=lastname]', $form).val(values.lastname);


      $(':input[name=password]', $form).removeAttr('required');
      $(':input[name=confirm_password]', $form).removeAttr('required');
    },

    /**
     * Resets the form to its default state. This is typically used when transitioning from editing
     */
    reset: function () {
      const $form = $('form[name=aimi-collaborator]');
      $(':input[name=id]', $form).val('');
      $(':input[name=email]', $form).val('');
      $(':input[name=firstname]', $form).val('');
      $(':input[name=lastname]', $form).val('');
      $(':input[name=password]', $form).attr('required', 'required');
      $(':input[name=confirm_password]', $form).attr('required', 'required');
      $form.removeClass('was-validated');
    },

  }

  /**
   * List
   */
  aimi_calendar_approval.list = {
    listRow: 'collaborator__row',

    init: function () {
      const __view = aimi_calendar_approval.view;
      const self = aimi_calendar_approval.list;

      this.getOriginalTabs();

      const $listContainer = $('[data-collaborators]');

      __this.listMananger = new CollaboratorList(app, $listContainer, this.listRow, 'searchTable');

      __this.listMananger.renderList();

      $(document).off('click.aimi_scollaborator_list').on('click.aimi_collaborator_list', '.collaborator-row .btn-view', function (e) {
        aimi_calendar_approval.view.edit($(this).data('id'));
      });

      $(document).off("click.bs.tab").on("click.bs.tab", ".hk-pg-header a[data-bs-toggle='tab']", function (e) {
        let $this = $(this);
        const href = $this.attr('href');
        self.setViewTabTitle();
        __view.reset();
      });

      $(document).off('click.aimi_collaborator_list_delete').on('click.aimi_collaborator_list_delete', 'tr:not(.pre-loader) .btn-delete', function (e) {
        let id = $(this).data('id');
        app.confirm("Delete Collaborator?", "Are you sure you want to delete this Collaborator?").then(function (response) {
          const $button = response.button;
          const confirm = response.confirm;
          const $modal = response.modal;

          // If the user confirms the deletion, proceed with the delete operation.
          if (confirm === true) {
            app.doButtonAction($button);
            app.apis['collaborator'].delete(id).done(function (response) {
              if (response.success !== true) {

              } else {
                // Render list if deleted
                __this.listMananger.renderList();
              }
              app.doButtonReset($button);
              app.hideModal($modal);
            }).fail(function (response) {
              app.doButtonReset($button, false);
              app.hideModal($modal);
            });
          }
        });
      });
    },

    /**
     * Retrieves and stores the original titles of tabs within the page, allowing for dynamic updates
     * to tab titles based on user interaction.
     */
    getOriginalTabs: function () {
      __this.tabs = {};
      _.each($('.hk-pg-header a[data-bs-toggle="tab"]'), function (row) {
        let $row = $(row);
        __this.tabs[$row.attr('href')] = $('.nav-link-text', $row).text();
      });
    },
    /**
     * Dynamically sets the title of a view or edit subuser tab. If no title is specified, resets
     * the title to its original value.
     * @param {string|null} title - The new title for the tab or null to reset to the original title.
     */
    setViewTabTitle: function (title = null) {
      const subuserTab = '#tab_block_3';
      let $newUserTab = $(`a[href="${subuserTab}"]`);
      if (title == null) {
        title = __this.tabs[subuserTab];
      }
      $('.nav-link-text', $newUserTab).text(title)
    }
  }

  aimi_calendar_approval.updateCallBack = function (response) {
    response.message = 'Collaborator saved successfully';
    app.notifyEl.update({'message': response.message, progress: 90});
    __this.listMananger.renderList().then(function () {
      Utils.createAndShowTab('#tab_block_2');
      aimi_calendar_approval.list.setViewTabTitle();
    });
  }

  aimi_calendar_approval.settingsPayloadProcessor = function (requestData) {
    requestData.logo = __this.logo;
    requestData.autoSchedule = requestData.autoSchedule === 'on';
    return requestData;
  }

  aimi_calendar_approval.settingsUpdateCallBack = function (response) {
    response.message = 'Settings saved successfully';
    const self = aimi_calendar_approval.settings;
    const $form = $('form[name="aimi-approval-settings"]');

    app.apis['approvalSettings'].get().then(function (response) {
      self.setValues($form, response);
      app.notifyEl.update({'message': response.message, progress: 90});
    });

  }

  aimi_calendar_approval.settings = {

    init: async function () {
      const self = aimi_calendar_approval.settings;
      const $form = $('form[name="aimi-approval-settings"]');
      __this.$logoDropify = $('.dropify-logo', $form);

      const clipboard = new ClipboardJS('.btn-copy-clipboard');

      clipboard.on('success', function (ce) {
        app.notify('success', "Copied To Device");
        ce.clearSelection();
      });

      const removePlaceholderLoader = () => {
        Utils.getTabContent('#tab_block_1').find('.placeholder-loader').removeClass('placeholder');
      }

      app.apis['approvalSettings'].get().then(function (response) {
        removePlaceholderLoader();
        self.setValues($form, response);
      });

      // Initialize Dropify (a file uploader) for headshot and logo image inputs.
      self.dropify('logo', __this.$logoDropify); // Enhance the headshot file input with Dropify.

      new SimpleBar(document.getElementById('tab_block_1'), {autoHide: true});
      new SimpleBar(document.getElementById('tab_block_2'), {autoHide: true});
      new SimpleBar(document.getElementById('tab_block_3'), {autoHide: true});
    },

    setCalendarUrl: function ($form, whiteLabelDomain) {
      const calendarId = app.calendarId;
      let calendarUrl = `${window['approvalUrl']}/calendar/approve/${calendarId}`;
      if (whiteLabelDomain !== '') {
        calendarUrl = `${whiteLabelDomain}/calendar/approve/${calendarId}`;
      }
      $(':input[name=calendar-url]', $form).val(calendarUrl);
      let $button = $('.btn-copy-clipboard', $form);
      $button.val(calendarUrl);
      $button.attr('data-clipboard-text', calendarUrl);

      return calendarUrl;
    },

    setValues: function ($form, values) {
      const $autoScheduleSwitch = $form.find(':input[name="autoSchedule"]');
      const $customMessageSwitch = $form.find(':input[name="messageCheckbox"]');
      const $whiteLabelDomain = $form.find(':input[name="whiteLabelDomain"]');
      const $message = $form.find(':input[name="message"]');
      const $contact = $form.find(':input[name="contact"]');

      if (!app.isEmpty(values.data)) {
        values = values.data;

        if (!app.isEmpty(values.logo) && !app.isEmpty(values.logo)) {
          this.setDropifyVal($('.dropify-logo'), values.logo.img)
          __this.logo = {
            img: values.logo.img,
            thumb: values.logo.thumb
          };
        }

        Utils.setSwitchVal($autoScheduleSwitch, true, true);
        $whiteLabelDomain.val(values.whiteLabelDomain);
        $contact.val(values.contact);

        if (!app.isEmpty(values.message)) {
          Utils.setSwitchVal($customMessageSwitch, true, false);
          $message.val(values.message);
        }
      } else {

      }
      this.setCalendarUrl($form, $whiteLabelDomain.val());
    },

    dropify: function (namespace, $container) {
      const self = this;
      const title = 'Logo';
      const inputName = 'logo';

      const options = {
        namespace: 'single-uploader', // Namespace for dropify instance
        title: `Upload ${title}`,  // Title for the input field
        input: inputName, // ID and name of the input field
        preview: false,
        multiple: false,
        button: false,
        autoupload: true
      }
      const $uploader = new Uploader(app, $container, options, null);

      const submitForm = async (input) => {
        const $form = input.closest('form');
        // Create a new 'submit' event
        const event = new Event('submit', {
          bubbles: true,    // The event will bubble up through the DOM
          cancelable: true  // The event can be canceled
        });
        $form[0].dispatchEvent(event);
        return $form;
      }

      const onFormSubmitComplete = function () {
        // Return a promise that resolves when the value changes
        return new Promise((resolve) => {
          // This function simulates the value change
          function checkValue() {
            // Simulate a condition check, e.g., value change
            if (__this.dropifyInProgress === false) {
              resolve(__this);
            } else {
              // Re-check the value every 100ms
              setTimeout(checkValue, 100);
            }
          }

          // Start checking the value
          checkValue();
        });
      }

      const removeCallback = function (input, $button) {
        const name = input.attr('name');

        if (name === 'logo') {
          __this.logo = {};
        }

        __this.dropifyInProgress = true;
        app.button($button, 'loading');

        submitForm(input.closest('form')).then(function () {
        })

        onFormSubmitComplete().then(function () {
          app.doButtonReset($button);
          self.setDropifyVal($container, '');
        })
      }

      const uploadCallback = async function (input, $button) {
        const file = input[0].files[0];

        app.doButtonAction($button);
        const response = await app.apis['uploads'].upload(file);

        const name = input.attr('name');

        if (name === 'logo') {
          __this.logo = {
            img: response.path,
            thumb: response.pathThumbnail
          };
        }

        __this.dropifyInProgress = true;
        submitForm(input.closest('form')).then(function () {

        });

        onFormSubmitComplete().then(function () {
          app.doButtonReset($button);
          self.setDropifyVal($container, response.path)
        })
      }

      return $uploader.dropifySingle(removeCallback, uploadCallback);
    },

    setDropifyVal: function ($container, value) {
      const $preview = $('.dropify-preview', $container);
      const $wrapper = $('.dropify-wrapper', $container);

      if (!app.isEmpty(value)) {
        const $render = $('.dropify-render', $preview);
        const $img = $('<img />').attr('src', value);
        const $uploadButton = $('.dropify-actions.btn-upload-image', $container);
        const $removeButton = $('.dropify-actions.btn-remove-image', $container);
        const $message = $('.dropify-message', $container);

        $render.empty();
        $removeButton.removeClass('d-none');
        $uploadButton.addClass('d-none');
        $message.hide();
        $img.appendTo($render);
        $preview.show();
      } else {
        const $actions = $('.dropify-actions', $container);
        const $message = $('.dropify-message', $container);

        $actions.addClass('d-none');
        $message.show();
        $preview.hide();
      }

    }
  }

}(window.aimi_calendar_approval = window.aimi_calendar_approval || {}, jQuery, PreBuilt));
